"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function ErrorIcon() {
    return (React.createElement("svg", { "data-qa": "error-icon", width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1" },
        React.createElement("defs", null,
            React.createElement("path", { d: "M12,3 C7.05,3 3,7.05 3,12 C3,16.95 7.05,21 12,21 C16.95,21 21,16.95 21,12 C21,7.05 16.95,3 12,3 Z M5,11.971831 C5,8.13732394 8.13732394,5 11.971831,5 C13.4823944,5 14.8767606,5.46478873 16,6.27816901 L6.27816901,16 C5.46478873,14.8767606 5,13.4823944 5,11.971831 L5,11.971831 Z M12.028169,19 C10.5176056,19 9.12323944,18.5352113 8,17.721831 L17.721831,8 C18.5352113,9.12323944 19,10.5176056 19,12.028169 C19,15.8626761 15.8626761,19 12.028169,19 Z", id: "path-1" })),
        React.createElement("g", { id: "icons/general/error", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            React.createElement("mask", { id: "mask-2", fill: "white" },
                React.createElement("use", { xlinkHref: "#path-1" })),
            React.createElement("use", { id: "\uD83C\uDFA8-Color", fill: "#706E6B", xlinkHref: "#path-1" }),
            React.createElement("g", { id: "colors/black/350_highlight_L", mask: "url(#mask-2)", fill: "#ffffff" },
                React.createElement("rect", { id: "Color", x: "0", y: "0", width: "24", height: "24" })))));
}
exports.ErrorIcon = ErrorIcon;
